/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { DashboardGraphLayout } from '../models/DashboardGraphLayout';

export class CreateGraphInput {
  /**
  * The title of the graph
  */
  'title': string;
  /**
  * The chart visualization type
  */
  'chartType': CreateGraphInputChartTypeEnum;
  /**
  * The SQL query that provides data for the graph
  */
  'sqlQuery': string;
  /**
  * Mapping of chart axes to query result columns
  */
  'columnMapping'?: { [key: string]: any; };
  'layout'?: DashboardGraphLayout;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "title",
      "baseName": "title",
      "type": "string",
      "format": ""
    },
    {
      "name": "chartType",
      "baseName": "chartType",
      "type": "CreateGraphInputChartTypeEnum",
      "format": ""
    },
    {
      "name": "sqlQuery",
      "baseName": "sqlQuery",
      "type": "string",
      "format": ""
    },
    {
      "name": "columnMapping",
      "baseName": "columnMapping",
      "type": "{ [key: string]: any; }",
      "format": ""
    },
    {
      "name": "layout",
      "baseName": "layout",
      "type": "DashboardGraphLayout",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CreateGraphInput.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum CreateGraphInputChartTypeEnum {
  Bar = 'BAR',
  Line = 'LINE',
  Pie = 'PIE',
  Area = 'AREA',
  Scatter = 'SCATTER',
  Donut = 'DONUT',
  Table = 'TABLE'
}

